import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
import { MenuNode } from '../../../../classes/MenuNode';
@Component({
	selector: 'app-help-screen',
	templateUrl: './help-screen.component.html',
	styleUrls: ['./help-screen.component.scss']
})

export class HelpScreenComponent implements OnInit, OnDestroy, AfterViewInit {
	_debug : boolean = false;
	debug(msg:string):void{
		if(this._debug){
			console.log("HelpScreenComponent: "+msg);
		}
	}


  	@ViewChild("helpText") helpText: ElementRef;
	_initTop = 18;
	_top=18;
	top="18%";
	_step=11.5;
	top_unit='%';
	eventSubscription$:any;
	scroll = 0;
	_scrollbarHeight=90;
	_scrollbarStep = 10;
	scrollbarHeight="90%";
	scrollbarTop="0%";
	icon="iconInformation";
	node:MenuNode;
	maxScrollIterations(){
		if(this.helpText){
			var el = this.helpText.nativeElement;
			var divHeight = el.offsetHeight
			let lineHeight = 28;
			return (divHeight - 110)/lineHeight;
		}
	}
	constructor(private menuService:MenuService, private ioService: DataIoService) { }
	ngOnInit() {
		this.node = this.menuService.getCurrentNode();
		let ico = this.node.getIcon();
		if(ico != ""){
			this.icon = ico;
		}
		this.debug("Loading view on "+this.node.getIdentifier());
		this.eventSubscription$ = this.ioService.inputs.events$.subscribe(
			(event)=>{
				this.eventHandler(event);
			},
			(error)=>{

			});
	}
	ngAfterViewInit(){
		if(this.maxScrollIterations() > 0){
			this.debug("Activating scrollbar.");
			this.menuService.setScrollbarNeededByHelpWidget(true);
		}else{
			this.debug("Deactivating scrollbar.");
			this.menuService.setScrollbarNeededByHelpWidget(false);
		}
		this._scrollbarHeight = 100 - (this._scrollbarStep*this.maxScrollIterations());
		this.scrollbarHeight = this._scrollbarHeight+"%";
		this.scrollbarTop = "0%";
		if(this.menuService.getCurrentNode().getIdentifier() == 'wizard_help'){
			this.ioService.deviceInfo().setValue('wizard_help_shown','yes');
			this.menuService.getCurrentNode().setTarget('goto:benutzerhandbuch');
		}
		
	}
	ngOnDestroy(){
		this.icon = "iconInformation";
		if(this.eventSubscription$){
			this.eventSubscription$.unsubscribe();
		}

	}
	get text(){
		return this.node.getText(0);
	}
	eventHandler(event){

		switch(event){
			case 'pandown':{
				return this.panUp();
				
			}
			case 'panup':{
				return this.panDown();
				
			}
			case 'panend':{
				return this.panEnd();

			}
			case 'up':{
				if(this.scroll < 0){
					this.scroll++;
				}

				return this.applyScroll();
			}
			case 'down':{
				if(this.scroll > (-1)*this.maxScrollIterations()){
					this.scroll--;
				}
				return this.applyScroll();

			}
			case 'question':{
				if(this.node.hasTarget()){
					let target = this.node.getTargetNode();
					if(target){
						this.menuService.goto(target);
						return;
					}
				}
				if(this.node.getIdentifier()=='wizard_help'){
					let benutzerhandbuch = this.menuService.findItem('benutzerhandbuch');
					this.menuService.goto(benutzerhandbuch);
					return;
				}
			}
			case 'back':{
				if(this.node.hasTarget()){
					let target = this.node.getTargetNode();
					if(target){
						this.menuService.goto(target);
						return;
					}
				}
				this.debug("Going back in history");
				this.menuService.historyBack();
				return;
			}
			default:{
			}
		}
	}
	applyScroll(){
				this._top = (this._initTop + this.scroll*this._step);
				this.top = this._top + this.top_unit;
				this.scrollbarTop = (-1*(this.scroll*this._scrollbarStep))+"%";
				
	}
	panEnd():void{
		this.scroll = parseInt(this.scroll+"");
		this.applyScroll();
	}
	panUp():void{
		if(this.scroll < 0){
			this.scroll+=0.3;
		}
	}
	panDown():void{
		if(this.scroll > (-1)*this.maxScrollIterations()){
			this.scroll-=0.3;
		}
		this.applyScroll();
	}


}
